import { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

import { User } from '@percent/cause-dashboard/context/auth/authContext/AuthContext.types'
import { Wizard } from './Wizard/Wizard'
import { SetupQRStepContainer } from './SetupQRStep/SetupQRStepContainer'
import { ConfirmationCodeStepContainer } from './ConfirmationCodeStep/ConfirmationCodeStepContainer'
import { SaveBackupCodeStep } from './SaveBackupCodeStep/SaveBackupCodeStep'
import { SetupComplete } from './SetupComplete/SetupComplete'
import { SET_AUTHORISED } from '@percent/cause-dashboard/context/auth/authReducer/authReducer'
import styles from './TwoFactorAuthenticationSetup.module.scss'
import { useAuthState } from '@percent/cause-dashboard/common/hooks/useAuthState/useAuthState'
import { useAuthDispatch } from '@percent/cause-dashboard/common/hooks/useAuthDispatch/useAuthDispatch'
import { RoutePath } from '@percent/cause-dashboard/app/routes/Routes'

export function TwoFactorAuthenticationSetup() {
  const { state } = useLocation()
  const {
    authState: { isAuthorised }
  } = useAuthState()
  const navigate = useNavigate()
  const { authDispatch } = useAuthDispatch()
  const [userData, setUserData] = useState<undefined | User>(undefined)

  const onFinish = () => {
    authDispatch({
      type: SET_AUTHORISED,
      payload: {
        user: userData
      }
    })

    navigate(RoutePath.MY_ACCOUNT)
  }

  useEffect(() => {
    if (isAuthorised && !state.otpData) {
      navigate('/profile')
    }
  }, [isAuthorised, navigate, state])

  const steps = [
    {
      step: <SetupQRStepContainer />
    },
    {
      step: <ConfirmationCodeStepContainer setUserData={setUserData} />
    },
    {
      step: <SaveBackupCodeStep otpCode={userData?.twoFaBackupCode} />
    }
  ]

  useEffect(() => {
    if (!state?.password && !state?.otpData) {
      navigate('/signin')
    }
  }, [state, navigate])

  return (
    <div className={styles.container}>
      <Wizard steps={steps}>
        <SetupComplete onFinish={onFinish} />
      </Wizard>
    </div>
  )
}
